
import SecurityAwarenessTraining from "@/pages/cybersecurity/SecurityAwarenessTraining";
import PolicyProceduresDevelopment from "@/pages/cybersecurity/PolicyProceduresDevelopment";
import VulnerabilityManagement from "@/pages/cybersecurity/VulnerabilityManagement";
import NistAssessment from "@/pages/cybersecurity/NistAssessment";
import FinraAssessment from "@/pages/cybersecurity/FinraAssessment";
import HipaaReadinessAssessment from "@/pages/cybersecurity/HipaaReadinessAssessment";
import Nist80053Assessment from "@/pages/cybersecurity/Nist80053Assessment";
import IncidentResponseRemediation from "@/pages/cybersecurity/IncidentResponseRemediation";
import Nist800171Assessment from "@/pages/cybersecurity/Nist800171Assessment";
import CmmcAssessment from "@/pages/cybersecurity/CmmcAssessment";
import CybersecurityCompliance from "@/pages/cybersecurity/CybersecurityCompliance";
import AccessControlManagement from "@/pages/cybersecurity/AccessControlManagement";
import ManagedXdr from "@/pages/cybersecurity/ManagedXdr";
import PenetrationTesting from "@/pages/cybersecurity/PenetrationTesting";
import NistCsf from "@/pages/cybersecurity/NistCsf";
import CloudSoar from "@/pages/cybersecurity/CloudSoar";
import ManagedSiem from "@/pages/cybersecurity/ManagedSiem";
import ThreatHunting from "@/pages/cybersecurity/ThreatHunting";

export const cybersecurityRoutes = [
  { path: "/cybersecurity/security-awareness-training", element: <SecurityAwarenessTraining /> },
  { path: "/cybersecurity/policy-and-procedures-development", element: <PolicyProceduresDevelopment /> },
  { path: "/cybersecurity/vulnerability-management", element: <VulnerabilityManagement /> },
  { path: "/cybersecurity/nist-assessment", element: <NistAssessment /> },
  { path: "/cybersecurity/finra-assessment", element: <FinraAssessment /> },
  { path: "/cybersecurity/hipaa-readiness-assessment", element: <HipaaReadinessAssessment /> },
  { path: "/cybersecurity/nist-800-53-assessment", element: <Nist80053Assessment /> },
  { path: "/cybersecurity/incident-response-remediation", element: <IncidentResponseRemediation /> },
  { path: "/cybersecurity/nist-800-171-assessment", element: <Nist800171Assessment /> },
  { path: "/cybersecurity/cmmc-assessment", element: <CmmcAssessment /> },
  { path: "/cybersecurity/cybersecurity-compliance", element: <CybersecurityCompliance /> },
  { path: "/cybersecurity/access-control-management", element: <AccessControlManagement /> },
  { path: "/cybersecurity/managed-xdr", element: <ManagedXdr /> },
  { path: "/cybersecurity/penetration-testing", element: <PenetrationTesting /> },
  { path: "/cybersecurity/nist-csf", element: <NistCsf /> },
  { path: "/cybersecurity/cloud-soar", element: <CloudSoar /> },
  { path: "/cybersecurity/managed-siem", element: <ManagedSiem /> },
  { path: "/cybersecurity/threat-hunting", element: <ThreatHunting /> }
];
